class AccrualReportActions {
    static ACCRUAL_REPORT_REQUEST = "ACCRUAL_REPORT_REQUEST";
    static ACCRUAL_REPORT_SUCCESSFUL = "ACCRUAL_REPORT_SUCCESSFUL";
    static ACCRUAL_REPORT_FAILED = "ACCRUAL_REPORT_FAILED";
  
    static accrualReportRequest() {
      return {
        type: this.ACCRUAL_REPORT_REQUEST
      };
    }
    static accrualReportSuccessul(data) {
      return {
        type: this.ACCRUAL_REPORT_SUCCESSFUL,
        data
      };
    }
    static accrualReportFailed(error) {
      return {
        type: this.ACCRUAL_REPORT_FAILED,
        error
      };
    }
  }
  
  export default AccrualReportActions;
  